import type { ZeytalTokens } from "@zeytal/types";

import { camelize } from "@endgame/utils/camelize";

import { variableAliasKeyword } from "../../utils/tokens.ts";

const formatName = (name: ZeytalTokens.TransformedToken["name"]) => {
  return `"${camelize(name)}"`;
};

const booleanValue = (boolean: boolean) => `${boolean}`;

const numberValue = (number: number) => number.toString();

const stringValue = (string: string) => {
  return `"${string}"`;
};

const formatValue = (value: ZeytalTokens.TransformedToken["value"]): string => {
  switch (typeof value) {
    case "boolean":
      return booleanValue(value);
    case "number":
      return numberValue(value);
    case "string":
      return stringValue(value);
    default:
      return "null";
  }
};

export const translateJson = (
  variables: ZeytalTokens.TransformedTokensArray,
) => {
  // Deep copy of array to avoid mutating the orignal variables array
  const varsDeepCopy: ZeytalTokens.TransformedTokensArray = JSON.parse(
    JSON.stringify(variables),
  );

  const variablesByName = varsDeepCopy.reduce(
    (acc, v) => {
      return { ...acc, [v.name]: v.value };
    },
    {} as Record<string, ZeytalTokens.TransformedToken["value"]>,
  );

  const noAliasVariables = varsDeepCopy.map((v) => {
    if (
      typeof v.value !== "string" ||
      !v.value.startsWith(variableAliasKeyword)
    ) {
      return v;
    }

    v.value =
      variablesByName[v.value.replace(variableAliasKeyword, "")] ?? v.value;

    return v;
  });

  return (
    "{\n" +
    noAliasVariables.reduce(
      (acc, item, index) =>
        `${acc}  ${formatName(item.name)}: ${formatValue(item.value)}${index !== noAliasVariables.length - 1 ? "," : ""}\n`,
      "",
    ) +
    "}\n"
  );
};
